import React from 'react';
import Typography from '@mui/material/Typography';
import StarCards from '../components/resuableComponents/StarCards';
import { CChart } from '@coreui/react-chartjs';
import {
	Box,
	Card,
	Grid,
	Icon,
	IconButton,
	styled,
	Tooltip,
	useTheme,
} from '@mui/material';
import Doughnut from '../components/resuableComponents/Doughnut';

const StyledCard = styled(Card)(({ theme }) => ({
	display: 'flex',
	flexWrap: 'wrap',
	alignItems: 'center',
	justifyContent: 'space-between',
	padding: '24px !important',
	background: theme.palette.background.paper,
	[theme.breakpoints.down('sm')]: { padding: '16px !important' },
}));
const StyledCard2 = styled(Card)(({ theme }) => ({
	display: 'flex',
	flexWrap: 'wrap',
	alignItems: 'center',
	justifyContent: 'space-between',
	padding: '24px !important',
	background: theme.palette.background.paper,
	height: 500,
	[theme.breakpoints.down('sm')]: { padding: '16px !important' },
}));
const Dashboard = () => {
	const theme = useTheme();
	function progressBarScroll() {
		let winScroll =
				document.body.scrollTop || document.documentElement.scrollTop,
			height =
				document.documentElement.scrollHeight -
				document.documentElement.clientHeight,
			scrolled = (winScroll / height) * 100;
		document.getElementById('progressBar').style.width = scrolled + '%';
	}

	window.onscroll = function () {
		progressBarScroll();
	};
	return (
		<div>
			<div className='header' style={{ marginTop: 60 }}>
				<div className='progress-container'>
					<div className='progress-bar' id='progressBar'></div>
				</div>
			</div>
			<Grid container spacing={4}>
				<Grid item xs={8}>
					<StarCards />
					<StyledCard2 elevation={2}>
						<h2 style={{ color: 'black' }}>Latest Booking Details</h2>
					</StyledCard2>
				</Grid>
				<Grid item xs={4}>
					<StyledCard elevation={2}>
						{/* <span>Traffic Sources</span> */}
						<CChart
							type='doughnut'
							data={{
								labels: ['VueJs', 'EmberJs', 'ReactJs', 'AngularJs'],
								datasets: [
									{
										backgroundColor: [
											'#41B883',
											'#E46651',
											'#00D8FF',
											'#DD1B16',
										],
										data: [40, 20, 80, 10],
									},
								],
							}}
							options={{
								plugins: {
									legend: {
										labels: {
											color: 'red',
										},
									},
								},
							}}
						/>
					</StyledCard>
					<br />
					<StyledCard elevation={2}></StyledCard>
				</Grid>
			</Grid>
		</div>
	);
};

export default Dashboard;
